import { createUseGesture, pinchAction } from '@use-gesture/react';
import { useRef, useState } from 'react';

const useGesture = createUseGesture([pinchAction]);

const usePinchZoom = (scaleMax: number) => {
  const ref = useRef<HTMLImageElement>(null);
  const [crop, setCrop] = useState({ scale: 1 });
  const [pinchActive, setPinchActive] = useState(false);

  useGesture(
    {
      onPinch: ({ active, offset: [s] }) => {
        setCrop({ scale: s });
        if (active) {
          setPinchActive(true);
        } else {
          setPinchActive(false);
        }
      }
    },
    {
      target: ref,
      pinch: { scaleBounds: { min: 1, max: scaleMax } }
    }
  );

  return { ref, crop, pinchActive };
};

export default usePinchZoom;
